export function sanitizeCommentText(value: string): string {
  return String(value || '')
    .replace(/-->/g, '-- >')
    .replace(/\|/g, '｜')
    .replace(/\r?\n/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function createEpisodeAnchor(episodeNumber: number): string {
  return `episode-${episodeNumber}`;
}

export function formatTocLink(anchorId: string, label: string): string {
  return `<!-- novel-toc-link:${anchorId}|${sanitizeCommentText(label)} -->`;
}

export function formatPageStart(anchorId: string, pageTitle: string): string {
  const safeTitle = sanitizeCommentText(pageTitle);
  return `<!-- novel-anchor:${anchorId} -->\n<!-- pagebreak:${anchorId} -->\n<!-- === -->\n<!-- ${safeTitle} -->\n<!-- === -->`;
}
